import SinggleChoiceSetting from "./KrSinggleChoiceSetting.vue";
import { install } from "@kurundata-ui-questionnaire/utils/install";

const KrSinggleChoiceSetting = install(SinggleChoiceSetting); // 生成带有 install 方法的组件

export default KrSinggleChoiceSetting;
